import { render, staticRenderFns } from "./KalenderVeranstaltung.vue?vue&type=template&id=11daced6"
import script from "./KalenderVeranstaltung.vue?vue&type=script&lang=js"
export * from "./KalenderVeranstaltung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports